// extracted by mini-css-extract-plugin
export default {"header":"Header_header__5WaqR","left":"Header_left__3eTmV","search":"Header_search__yH+zs","right":"Header_right__nkxXl"};